import { SensorType } from '../../types/sensor-type';

export class CloudSecuritySensorView {
  static getRequirements(dependencies: any): string {
    return `
        <div class="sensor-requirement" sensor-type="${SensorType.CLOUD_SECURITY}">
          <gz-title class="sensor-title">${dependencies.translateFn('Make sure the following requirements are met:')}
          </gz-title>
          <ul>
            <li>${dependencies.translateFn('An active {activeCloudSecurity}.', {
              activeCloudSecurity:
                '<gz-link type="underline" href="https://www.bitdefender.com/business/support/en/77209-526727-licensing.html"><span>' +
                dependencies.translateFn('GravityZone Cloud Security (CSPM+) license') +
                '</span></gz-link>',
            })}</li>
            <li>${dependencies.translateFn(
              'An active license that includes the detection and response functionality.'
            )}</li>
            <li>${dependencies.translateFn('The GravityZone Cloud Security console is {provisioningAndAccess}.', {
              provisioningAndAccess:
                '<gz-link type="underline" href="https://www.bitdefender.com/business/support/en/77209-453803-getting-started.html"><span>' +
                dependencies.translateFn('provisioned and active') +
                '</span></gz-link>',
            })}</li>
          </ul>
          <span>${dependencies.translateFn(
            'When all requirements are met, the CSPM+ sensor integration automatically becomes active. You can view it in the Sensors Management grid.'
          )}</span>
        </div>
        `;
  }
}
